export default "__VITE_ASSET__81aa2a40__"